// 支付宝账号格式化
export const payinfoFormat = (paydata) => {
  if (paydata instanceof Object) {
    paydata = paydata.paydata;
  }

  if(paydata === undefined) return {}

  // 格式： 支付宝账号姓名:蔡年松,支付宝账号:i@cns.name
  const arr = [];

  paydata.split(',').map((str) => {
    let info = str.split(':') || null;
    if (info) {
      arr.push(info[1] || '');
    }
  });

  return {
    name: arr[0],
    account: arr[1],
  };
}

// 订单状态转中文
export const status2cn = ( row ) => {
  // row可以是对象也可以是一个状态
  let status = row instanceof Object ? row.status : row;
  return { 0: '申请中', 1: '成功', 2: '失败' }[status];
}

export const auditStatus2cn = (row) => {
  const status = row instanceof Object ? row.audit_status : row

  return {
    0: '待审核',
    1: '已提交',
    2: '已拒绝',
  }[status]
}
//防抖
export const debounce = (fn, delay = 300 ) => {
  let timer = null
  return ( ...args ) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    },  delay)
  }
}

